import * as React from "react";
import '../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import {translate} from "react-i18next";
import i18n from "i18next";
import {Button, Col, Row} from "reactstrap";
import "../vodafone.css"
import iconBackButton from "../media/icons/backButton.png"
import iconTechnicianWhite from "../media/icons/technician-white.png";
import {BrowserView,MobileView,isMobile,isIOS,isAndroid,isChrome,isFirefox} from "react-device-detect";

/**
 * @property mainButtonOnClick - Big red button onclick listener
 * @property mainButtonTextResource - Big red button text resource
 * @property backButtonOnClick - Back arrow button onclick listener. If this is set, the back button will be shown, otherwise it will be hidden
 * @property additionalText - If this is provided, the big red button will be slightly smaller and some extra text will be shown next to it
 */
class BottomBar extends React.Component {

    constructor(props){
        super(props);
    }

    render() {

        console.log( "FNX: BottomBar // render - props"); console.log( this.props );

        let buttonClassNames = "button-red"
        if(this.props.mainButtonIsActiveColor === false){
            buttonClassNames = "button-gray"
        }
		
		let redButtonDisabled = "";
		if(this.props.disabled === true){
			redButtonDisabled = 'disabled';
		}

        let buttonValidationClassNames = "button-white"

        // console.log("FNX / BottomBar / this.props.mainButtonOnClick + props complete: //START"); console.log( this.props.mainButtonOnClick ); console.log( this.props ); console.log( "//END" );
        const bigRedButton = <Button disabled={redButtonDisabled} className={buttonClassNames + " width-100"} style={{height:"48px"}}
            onClick={this.props.mainButtonOnClick}>
            {i18n.t(this.props.mainButtonTextResource, this.props)}
        </Button>;

        let content;

        const showBackButton = !!this.props.backButtonOnClick;
        const showAdditionalText = !!this.props.additionalText;

        const showBackButtonValidation = !!this.props.backButtonValidationOnClick;

        const showFullWidth = !!this.props.showFullWidth;
        let classNames = showFullWidth ? "bottom-bar-full-width bg-white" : "bottom-bar";

        const showDesktopVersion = !!this.props.showDesktopVersion;
        classNames = showDesktopVersion ? "round-corners bottom-bar-desktop" : classNames;
		
		if(typeof this.props.className != 'undefined'){
			classNames = classNames + " " + this.props.className;
		}

        const backButton = showBackButton ? <span><img src={iconBackButton} style={{height:"18px",width:"10px",marginTop:"14px"}} onClick={this.props.backButtonOnClick} /></span> : <span/>;
        const backButtonValidation = <Button className={buttonValidationClassNames + " button-white-grey-border width-100"} style={{minHeight:"48px"}}onClick={this.props.mainButtonOnClick}>{i18n.t(this.props.backValidationButtonTextResource, this.props)}</Button>;
        const additionalText = showAdditionalText ? <p className={"bottom-bar-text"} >{i18n.t(this.props.additionalText, this.props)}</p> : <span/>;

        // #268 CARE-803 WEB: Datenschutzhinweis und Cookies / Topnavigation - Footer Buttons
            const showFooterButtons = !!this.props.showFooterButtons;
            const footerButtonConditions = <Button className={buttonValidationClassNames + " button-white-grey-border width-100"} style={{minHeight:"48px"}}onClick={this.props.footerButtonConditionsOnClick}>{i18n.t(this.props.footerButtonConditionsTextResource, this.props)}</Button>;
            const footerButtonImprint = <Button className={buttonValidationClassNames + " button-white-grey-border width-100"} style={{minHeight:"48px"}}onClick={this.props.footerButtonImprintOnClick}>{i18n.t(this.props.footerButtonImprintTextResource, this.props)}</Button>;
            const footerButtonPrivacy = <Button className={buttonValidationClassNames + " button-white-grey-border width-100"} style={{minHeight:"48px"}}onClick={this.props.footerButtonPrivacyOnClick}>{i18n.t(this.props.footerButtonPrivacyTextResource, this.props)}</Button>;

        // #208 CARE-833 WEB: Features - "Zum HomeScreen hinzuf�gen"
            const showHomescreenButtons = !!this.props.showHomescreenButtons;
            const homescreenButtonBookmark = <Button className={buttonValidationClassNames + " button-white-grey-border width-100 ico-bookmark"} style={{minHeight:"48px"}}onClick={this.props.homescreenButtonBookmarkOnClick}>{i18n.t(this.props.homescreenButtonBookmarkTextResource, this.props)}</Button>;
            const homescreenButtonHomescreen = <Button className={buttonValidationClassNames + " button-white-grey-border width-100 ico-homescreen"} style={{minHeight:"48px"}}onClick={this.props.homescreenButtonHomescreenOnClick}>{i18n.t(this.props.homescreenButtonHomescreenTextResource, this.props)}</Button>;
            const homescreenButtonCopy = <Button className={buttonValidationClassNames + " button-white-grey-border width-100 ico-copy"} style={{minHeight:"48px"}}onClick={this.props.homescreenButtonCopyOnClick}>{i18n.t(this.props.homescreenButtonCopyTextResource, this.props)}</Button>;

        // show buttons depending on switches/conditions
        if(showBackButton || showAdditionalText){

            content = <Row>
                <Col xs={2}>
                    {backButton}
                </Col>
                <Col xs={4} style={{paddingLeft:"0", paddingRight:"0", marginLeft:"-6px",marginTop:"10px"}}>
                    {additionalText}
                </Col>
                <Col xs={6}>
                    {bigRedButton}
                </Col>
            </Row>

        }else if(showBackButtonValidation){

            content = <Row>
                <Col xs={12}>
                    {backButtonValidation}
                </Col>
            </Row>

        // #268 CARE-803 WEB: Datenschutzhinweis und Cookies / Topnavigation - show Footer Buttons
        }else if(showFooterButtons){

            content = <Row>
                <Col xs={{size:12}} style={{paddingTop:"30px"}}>
                    {footerButtonConditions}
                </Col>
                <Col xs={12} style={{paddingTop:"30px"}}>
                    {footerButtonImprint}
                </Col>
                <Col xs={12} style={{paddingTop:"30px"}}>
                    {footerButtonPrivacy}
                </Col>
            </Row>

        // default Button
        }else if(showHomescreenButtons){

            if((isMobile && (isAndroid || isIOS))){

                content = <Row>
                            <Col xs={{size:12}} style={{paddingTop:"30px"}}>
                                {homescreenButtonBookmark}
                            </Col>
                            <Col xs={12} style={{paddingTop:"30px"}}>
                                {homescreenButtonHomescreen}
                            </Col>
                            <Col xs={12} style={{paddingTop:"30px"}}>
                                {homescreenButtonCopy}
                            </Col>
                        </Row>
                }else if(isMobile){
                    content = <Row>
                        <Col xs={12} style={{paddingTop:"30px"}}>
                            {homescreenButtonCopy}
                        </Col>
                    </Row>
                }else{
                    content = <Row>
                        <Col xs={{size:12}} style={{paddingTop:"30px"}}>
                            {homescreenButtonBookmark}
                        </Col>
                        <Col xs={12} style={{paddingTop:"30px"}}>
                            {homescreenButtonCopy}
                        </Col>
                    </Row>
                }
        // default Button
        }else{

            content = <Row>
                <Col xs={12}>
                    {bigRedButton}
                </Col>
            </Row>

        }

        return <div className={classNames}>{content}</div>
    }
}

export default translate("translations")(BottomBar);